import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user/user.service';
import { forkJoin } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { User } from 'src/app/classes/User';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { ConfirmDialogComponent } from 'src/app/components/dialog/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-user-subscriptions-info',
  templateUrl: './user-subscriptions-info.component.html',
  styleUrls: ['./user-subscriptions-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('accordionAnimation', [
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      state('open', style({ height: '*', opacity: 1 })),
      transition('closed <=> open', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})
export class UserSubscriptionsInfoComponent implements OnInit {

  @Input() user: User;

  public userBookedLessons = {};
  public loading: boolean;
  public activeIndex: number | null = null;
  public removingSubscriptionId: number | null = null;
  public errorMessage: string;
  private hasChanges = false;

  constructor(
    private activeModal: NgbActiveModal,
    private userService: UserService,
    private subscriptionService: SubscriptionService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit(): void {
    this.getUserBookedLessonsBySubscriptionId();
  }

  public getUserBookedLessonsBySubscriptionId(): void {
    if (!this.user?.subscriptions?.length) {
      this.userBookedLessons = {};
      this.loading = false;
      return;
    }

    this.loading = true;
    const queries = [];
    this.user.subscriptions.map(subscription => {
      queries.push(this.userService
        .getUserBookedLessonsBySubscriptionId(
          subscription.id,
          subscription.lessonsCountInitial - (subscription.lessonsCountLeft <= subscription.lessonsCountInitial ?
            subscription.lessonsCountLeft :
            subscription.lessonsCountInitial) || subscription.lessonsCountInitial || 10
        ));
    });
    forkJoin(queries).subscribe(responsesArray => {
      this.user.subscriptions.map((s, index) => {
        this.userBookedLessons[s.id] = responsesArray[index];
      });
      this.loading = false;
    });
  }

  closeModal(sendData): void {
    this.activeModal.close(this.hasChanges ? 'updated' : sendData);
  }

  toggleItem(index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
  }

  public removeSubscription(subscriptionId: number, subscriptionName: string): void {
    const dialog = this.modalService.open(ConfirmDialogComponent, {
      scrollable: true,
      windowClass: 'modal-confirm',
      size: 'md',
      centered: true,
    });

    dialog.componentInstance.message =
      `Remove subscription <strong>${subscriptionName}</strong>?`;
    dialog.componentInstance.confirmButtonMessage = 'Remove';

    dialog.result.then(
      (result) => {
        if (result.status === 'confirmed') {
          this.errorMessage = null;
          this.removingSubscriptionId = subscriptionId;
          this.subscriptionService.deletePurchasedSubscription(subscriptionId).subscribe({
            next: () => {
              this.user.subscriptions = this.user.subscriptions
                .filter(subscription => subscription.id !== subscriptionId);
              delete this.userBookedLessons[subscriptionId];
              this.hasChanges = true;
              if (this.activeIndex !== null && this.activeIndex >= this.user.subscriptions.length) {
                this.activeIndex = this.user.subscriptions.length - 1;
              }
              this.removingSubscriptionId = null;
            },
            error: (error) => {
              this.errorMessage = error.error?.error || 'Failed to remove subscription';
              this.removingSubscriptionId = null;
            }
          });
        }
      },
      () => {}
    );
  }
}
